import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const StyledIntegerInput = styled.input`
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  padding: 10px;
`

export const IntegerInputContainer = styled(FlexContainer)`
  width: 100%;
`
